import { React } from '../../libraries';
import { FooterComponent } from '../../components';

class Footer extends React.Component {
    render() {
        const { addreass, email, phone, linkDownload } = this.props;
        return(
            <>
                <div className="footer-container w-full lg:px-32 md:px-16 px-6 lg:py-16 py-5 " style={{backgroundColor: '#f5f6f8'}}>
                    <div className="container xl:px-20 lg:px-2">
                        <FooterComponent 
                            addreass={addreass} 
                            email={email} 
                            phone={phone} 
                            linkDownload={linkDownload} />
                    </div>
                </div>
            </>
        );
    }
}

export default Footer;